export interface Subscription {
  status: string;
  is_active: boolean;
  cancel_at_period_end: boolean;
  current_period_end: string;
  next_billing_date: string;
  ads: SubscriptionAdsQuota;
  ads_edit: SubscriptionAdsQuota;
  plan: SubscriptionPlan;
}

export interface SubscriptionAdsQuota {
  used: number;
  total_limit: number;
  base_limit: number;
  purchased_limit: number;
  remaining: number;
}

export interface SubscriptionPlan {
  id: string;
  name: string | null;
  amount: number;
  currency: string;
  interval: string;
  interval_count: number;
}

export interface SubscriptionDetails {
  subscription: Subscription;
  invoices: Invoice[];
  upcoming_invoice: UpcomingInvoice;
}

export interface Invoice {
  id: string;
  total: string;
  currency: string;
  invoice_pdf: string;
  created: Date;
}

export interface UpcomingInvoice {
  id: string;
  total: number;
  currency: string;
  invoice_pdf: string;
  status: string;
  created: Date;
}

export enum AdditionalAdsType {
  Purchase = 'purchase',
  Decrease = 'decrease ',
  Remove = 'remove',
}

export interface Addons {
  id: string;
  name: string;
  price: {
    amount: number;
    currency: string;
  };
}

export interface AdditionalAdsPreview {
  amount_due: number;
  currency: string;
  lines: { description: string; amount: number; quantity: number }[];
  total: number;
}
